import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loading from '../../shared/components/Loading';

const AdminRoute = () => {
    const { currentUser, isAdmin, loading } = useAuth(); // Assuming loading might be exposed, if not we rely on parent auth loading

    // If AuthContext is still loading (if we exposed it), we can show a loader. 
    // But typically AuthProvider blocks render until loading is false.

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    if (!isAdmin) {
        return <Navigate to="/home" replace />;
    }

    return <Outlet />;
};

export default AdminRoute;
